jQuery(function( $ ) {
    "use strict"

    let previousValue, // value of preference before change
        currentPreference; // the preference currently being edited.

    $( '.ajax-preference' ).on( 'focus', function() {
        previousValue = $( this ).val();
    });

    $( '.ajax-preference' ).on( 'change', function() {
        let name = $( this ).prop( 'id' ),
            value = $( this ).val();

        let undoFunction = update_preference.bind( this, name, value, previousValue ),
            redoFunction = update_preference.bind( this, name, previousValue, value );

        window.undoManager.add({
			undo: undoFunction,
			redo: redoFunction,
		});

        redoFunction();

    });

    /*
    * Questions/topics to discuss with Jason:
    * What are we clearing exactly?
    * Is it practical to check for specific local storage items before clearing?
    * We want to show the user some kind of confirmation that the data is cleared and perhaps disable the local storage button until the browser stores new local key/value pairs. ( Can check this with with localStorage.length ). May need to look at converting some localStorage objects to sessionStorage
    */
    $( '.clear-local-storage' ).on( 'click', function() {
        localStorage.clear();
    });

    function update_preference( name, prevValue, value ) {

        let currentPreference = $( '#' + name ),
            args = {
    			data : {
                    action: 'update_preference',
                    name: name,
                    value: value
    	        },
                canUndo: true,
                loadingMessage: 'Updating User Preference',
                successMessage: 'Updated User Preference',
                onSuccess : function() {
                    currentPreference.val( value );
                    previousValue = value;
                },
                onError : function() {
                    currentPreference.val( prevValue );
                    previousValue = prevValue;
                }
    		};

		window.ajaxCall( args );
    }


});
